import React from 'react';
import { Group, Switch, Badge } from '@landr/maestro';
import { t } from '@lingui/macro';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';

const FrequencySwitch = () => {
    const {
        yearlySaving,
        hasSale,
        showYearly,
        handleFrequencyChange,
        showFrequencySwitch,
    } = useUpsellActionsContext();

    if (!showFrequencySwitch) {
        return null;
    }

    return (
        <Group.Item alignSelf="center">
            <Group direction="horizontal" alignItems="center" gap="xs">
                <Switch
                    isOn={showYearly}
                    size="md"
                    onLabel={t`Yearly`}
                    offLabel={t`Monthly`}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        handleFrequencyChange(event.target.checked)
                    }
                />
                {!hasSale && (
                    <Badge
                        size="sm"
                        variant="warning"
                        kind="subtle"
                        label={t`SAVE ${yearlySaving}%`}
                    />
                )}
            </Group>
        </Group.Item>
    );
};

export default FrequencySwitch;
